export default [
  {
    altText: "Shop",
    bannerID: "Shop",
    buttonText: "",
    buttonUrl: "https://www.airasia.com/shop/th/th",
    redirectUrl: "https://www.airasia.com/shop/th/th",
    desktopImage:
      "https://www.airasia.com/aa/images/web-apps/supersale-2023/jul/th/aaHero-Banner-D-1270x280-TH.png",
    headline: "",
    mobileImage:
      "https://www.airasia.com/aa/images/web-apps/supersale-2023/jul/th/aaHero-Banner-M-720x200-TH.png",
    subheadline: "",
    tabletImage:
      "https://www.airasia.com/aa/images/web-apps/supersale-2023/jul/th/aaHero-Banner-D-1270x280-TH.png",
  }
]
